import { Skeleton as MuiSkeleton, type SkeletonProps as MuiSkeletonProps } from '@mui/material';

import type { WithoutStyleOverrides } from '../../../types/WithoutStyleOverrides';

type Props = WithoutStyleOverrides<MuiSkeletonProps>;

export function Skeleton(props: Props) {
  return <MuiSkeleton {...props} />;
}

export type { Props as SkeletonProps };
